<template>
  <!-- 骨密度筛查  -->
  <div v-if="model && model.bmdReport">
    <div id="print_bmdReport" class="page bmdReport-page" style="margin:0 auto; border:0px solid #E8E8EC;">
      <div style="height: 50px;"></div>
      <div style="font-size: 18px;"><span>{{ model.bmdReport.hospitalName ? model.bmdReport.hospitalName : ""}}</span></div>
      <div style="font-size: 22px;padding: 20px 0 30px 0;font-weight: 600;"><span>{{ model.bmdReport.reportName ? model.bmdReport.reportName : "体检报告" }}</span></div>

      <table style="margin-top: 15px;text-align: left;width: 100%;border-collapse: collapse;border:none;border-bottom:1px solid rgb(14, 14, 14);">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">学校：<span>{{ model.bmdReport.schoolName ? model.bmdReport.schoolName : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">年级：<span>{{ model.bmdReport.gradeName ? model.bmdReport.gradeName : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">班级：<span>{{ model.bmdReport.className ? model.bmdReport.className : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">编号：<span>{{ model.bmdReport.barCode ? model.bmdReport.barCode : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;"></td>
            <td style="border-collapse: collapse;border:none;">筛查时间：<span>{{ model.bmdReport.screenTime ? model.bmdReport.screenTime : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">姓名：<span>{{ model.bmdReport.name ? model.bmdReport.name : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">性别：<span>{{ model.bmdReport.sex ? model.bmdReport.sex : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">年龄：<span>{{ model.bmdReport.age ? model.bmdReport.age : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <div style="display: table;width:100%;line-height: 25px;text-align: left;margin-left:20px;margin-top: 20px;">
        <div style="display: table-cell;width:50%;font-size: 15px;">
          <div style="display: flex;"><div style="width:33%;font-size: 15px;">SOS声速</div><div>{{ model.bmdReport.sosSpeed ? model.bmdReport.sosSpeed : "" }}</div></div>
          <div style="display: flex;"><div style="width:33%;font-size: 15px;">同龄百分比</div><div>{{ model.bmdReport.sameAge ? model.bmdReport.sameAge : "" }}</div></div>
          <div style="display: flex;"><div style="width:33%;font-size: 15px;">Z-SCORE值</div><div>{{ model.bmdReport.zscore ? model.bmdReport.zscore : "" }}</div></div>
          <div style="display: flex;"><div style="width:33%;font-size: 15px;">Z-SCORE指示</div><div>{{ model.bmdReport.zscoreIndicate ? model.bmdReport.zscoreIndicate : "" }}</div></div>
        </div>
        <div style="display: table-cell;width:50%;font-size: 15px;">
          <div style="display: flex;"><div style="width:33%;font-size: 15px;">成人百分比</div><div>{{ model.bmdReport.adult ? model.bmdReport.adult : "" }}</div></div>
          <div style="display: flex;"><div style="width:33%;font-size: 15px;">T-SCORE值</div><div>{{ model.bmdReport.tscore ? model.bmdReport.tscore : "" }}</div></div>
          <div style="display: flex;"><div style="width:33%;font-size: 15px;">T-SCORE指示</div><div>{{ model.bmdReport.tscoreIndicate ? model.bmdReport.tscoreIndicate : "" }}</div></div>
        </div>
      </div>

      <div class="textCenter" style="text-align: center;">结果图示</div>
      <div style="display: table;width:100%;text-align: center;margin-top: 10px;border-bottom: 1px solid rgb(143, 143, 143);padding-bottom: 30px;">
          <div id="boneLineChart" style="text-align: center;width: 430px;height: 300px;margin-left: 20%;"/>
      </div>

      <table style="margin-top: 30px;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">
              <div><p style="font-size: 23px;font-weight: bold;">筛查小结</p></div>
              <div style="min-height: 20px;"><p>{{ model.bmdReport.summary ? model.bmdReport.summary : "" }}</p></div>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>

</template>
<script>

import {_bmdReport} from "@/services/report/report";
export default {
  name: "bmdReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        bmdReport:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    }
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'bmdReport'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'bmdReport') {
          this.model = newVal;
          this.initBmdReportChart();
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods:{
    loadData(){
      if(this.barCode){
        this.bmdReport(this.barCode);
      }
    },
    bmdReport(barCode) {
      _bmdReport({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
        this.initBmdReportChart();
      })
    },
    async initBmdReportChart() {
      await this.loadBmdReportScript(); // 确保脚本加载完成
      this.boneLineEcharts();
    },
    loadBmdReportScript() {
      return new Promise((resolve, reject) => {
        if (window.echarts) return resolve();

        const script = document.createElement('script');
        script.src = `/loadScript/echarts.min.js?v=${Date.now()}`; // 指向 public 目录
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    boneLineEcharts(){
      let chart = document.getElementById('boneLineChart');
      let boneLineChart = echarts.init(chart, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });

      let xdata = [];
      if (this.model.bmdReport.one && this.model.bmdReport.one.length > 0) {
        let max = 0, min = 0;
        let data = this.model.bmdReport.one;
        if (data) {
          if (data.length < 22) {
            for (let dataKey = 0; dataKey <= 19; dataKey++) {
              xdata.push(dataKey);
            }
            if (this.model.bmdReport.sex === '男') {
              max = 4140;
              min = 2760;
            } else {
              max = 4400;
              min = 2800;
            }
          } else {
            for (let _dataKey = 0; _dataKey <= 60; _dataKey++) {
              xdata.push(_dataKey + 20);
            }
            if (this.model.bmdReport.sex === '男') {
              max = 4585;
              min = 3365;
            } else {
              max = 4485;
              min = 3565;
            }
          }

          let option = {
            animation: false,
            // 关闭动画，否则动画效果影响打印
            title: {
              text: ''
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: []
            },
            grid: {
              left: '8%',
              right: '4%',
              bottom: '8%',
              top: '4%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: false
              }
            },
            xAxis: {
              name: '年龄【岁】',
              nameTextStyle: {
                // x轴name的样式调整
                color: 'rgb(0, 0, 0)',
                fontSize: 16,
                fontFamily: '仿宋'
              },
              nameGap: 20,
              // x轴name与横坐标轴线的间距
              nameLocation: "middle",
              // x轴name处于x轴的什么位置
              type: 'category',
              boundaryGap: false,
              splitLine: {
                show: true,
                lineStyle: {
                  // type:'solid',
                  // color:'rgb(0, 0, 0)'
                }
              },
              data: xdata
            },
            yAxis: {
              name: '超声速度[米/秒(m/dec)]',
              nameTextStyle: {
                // y轴name的样式调整
                color: 'rgb(0, 0, 0)',
                fontSize: 16,
                fontFamily: '仿宋',
                wordWrap: 'break-word'
              },
              nameRotate: 90,
              // y轴name旋转90度 使其垂直
              nameGap: 40,
              // y轴name与横纵坐标轴线的间距
              nameLocation: "middle",
              // y轴name处于y轴的什么位置
              type: 'value',
              min: min,
              max: max
            },
            series: [{
              name: '',
              type: 'line',
              symbol: 'circle',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  color: 'rgb(18,12,66)' //折线图与小圆点颜色
                }
              },
              data: this.model.bmdReport.five
            }, {
              name: '',
              type: 'line',
              symbol: 'circle',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  color: 'rgb(18,12,66)' //折线图与小圆点颜色
                }
              },
              data: this.model.bmdReport.four
            }, {
              name: '',
              type: 'line',
              symbol: 'circle',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  color: data.length > 22 ? 'rgb(18,12,66)' : 'rgb(255,128,65)' //折线图与小圆点颜色
                }
              },
              data: this.model.bmdReport.three
            }, {
              name: '',
              type: 'line',
              symbol: 'circle',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  color: data.length < 22 ? 'rgb(18,12,66)' : 'rgb(255,128,65)' //折线图与小圆点颜色
                }
              },
              data: this.model.bmdReport.two
            }, {
              name: '',
              type: 'line',
              symbol: 'circle',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  color: 'rgb(18,12,66)' //折线图与小圆点颜色
                }
              },
              data: this.model.bmdReport.one
            }, {
              name: '',
              type: 'line',
              symbol: 'circle',
              showAllSymbol: true,
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: 'rgb(255,66,69)' //折线图与小圆点颜色
                }
              },
              data: this.model.bmdReport.bmdValue
            }]
          };
          if (option && typeof option === 'object') {
            boneLineChart.setOption(option);
          }
          window.addEventListener('resize', boneLineChart.resize);
        }
      }
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .bmdReport-page {
    page: bmdReport-page; /* 绑定唯一命名 */
  }
  @page bmdReport-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:10px;padding-left:40px;padding-right:40px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}

</style>
